import { environment } from '@environment/environment';

export abstract class DebugHelper {
  static log(...args: any): void {
    if (environment.production) { return; }

    console.log(`⚠️ [Begin DEBUG] ⚠️`);
    console.log(...args);
    console.log(`⚠️ [End DEBUG] ⚠️`);
  }

  static error(...args: any): void {
    if (environment.production) { return; }

    console.log(`⚠️ [Begin DEBUG Error] ⚠️`);
    console.error(...args);
    console.log(`⚠️ [End DEBUG Error] ⚠️`);
  }
}
